import { render } from "./Vacunas.vue?vue&type=template&id=5819b363"
import script from "./Vacunas.vue?vue&type=script&lang=js"
export * from "./Vacunas.vue?vue&type=script&lang=js"

import "./Vacunas.vue?vue&type=style&index=0&id=5819b363&lang=css"
script.render = render

export default script